import { render, staticRenderFns } from "./cool.phoneCode.vue?vue&type=template&id=218169b6&scoped=true"
import script from "./cool.phoneCode.vue?vue&type=script&lang=js"
export * from "./cool.phoneCode.vue?vue&type=script&lang=js"
import style0 from "./cool.phoneCode.vue?vue&type=style&index=0&id=218169b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218169b6",
  null
  
)

export default component.exports